import { styled } from '@mui/system';

interface ContentDivProps {
  desktopHeight?: string;
  mobileHeight?: string;
  removePadding?: boolean;
  isSafari?: boolean;
}

const ContentDiv = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'mobileHeight' &&
    prop !== 'desktopHeight' &&
    prop !== 'isSafari' &&
    prop !== 'removePadding',
})<ContentDivProps>(
  ({ removePadding, desktopHeight, mobileHeight, isSafari, theme }) => ({
    display: 'flex',
    padding: removePadding ? 0 : '16px 12px',
    overflow: 'scroll',
    backgroundColor: '#F9F9F9',
    flexDirection: 'column',
    height: mobileHeight ? mobileHeight : 'calc(100dvh - 64px)',
    '@media (min-width: 900px)': {
      height: desktopHeight ? desktopHeight : 'calc(90dvh - 150px)',
      paddingBottom: '10px',
    },
    [theme.breakpoints.down(900)]: {
      paddingBottom: isSafari ? '180px' : '100px',
    },
  }),
);

export { ContentDiv };
